import _ from 'lodash';
import Element from '../ui/Element';
import mixin from '../privates/utils/mixin';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';

/**
 * @mixin IFrame
 * @summary Provides functionality for iframe-based elements, such as `HtmlComponent`.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @tagname IFrame
 */
class IFrame extends Element {
    constructor(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        super(RMI, compId, contextId, wixSelector, controllerId, role, type);

        const publicAPI = RMI.getPublicAPI(compId);
        if (_.isFunction(publicAPI)){
            const controllerData = RMI.getData(compId);
            _.assign(this, publicAPI(RMI.getCurrentScope(), wixSelector.scoped$W(controllerData.id)));
        } else if (publicAPI) {
            _.assign(this, publicAPI);
        }
    }
}

mixin(IFrame.prototype, HiddenCollapsedMixin.prototype);

export default IFrame;
